
  export default {
    props: {
      order: {
        required: true,
        default: {},
        type: Object,
      },
    },
    computed: {
      duration() {
        if (this.order.totalDurationInMinutes) {
          return this.order.totalDurationInMinutes
        } else {
          let ret = 0;
          if (this.order.treatments) {
            this.order.treatments.forEach(t => {
              ret += Math.round(t.durationInMinutes)
            })
          }
          return ret
        }
      },
      fromAndToTime() {
        if (this.order.fromTime && this.order.toTime) {
          return `, kl ${this.$moment(this.order.fromTime).format("HH:mm")} - ${this.$moment(this.order.toTime).add(1, "seconds").format("HH:mm")}`
        } else if (this.order.startTimeTreatments && this.order.endTimeTreatments) {
          return `, kl ${this.$moment(this.order.startTimeTreatments).format("HH:mm")} - ${this.$moment(this.order.endTimeTreatments).add(1, "seconds").format("HH:mm")}`
        } else {
          return ''
        }
      },
      formatTitle() {
        let ret = ''
        if (this.order.treatmentNames) {
          ret = this.order.treatmentNames
        } else {
          if (this.order.treatments) {
            this.order.treatments.forEach(t => {
              ret += t.treatmentName + ','
            });
          }
        }
        let max = this.$vuetify.breakpoint.mdAndDown ? 30 : 50
        return ret.length > max ? ret.substring(0, max) + '...' : ret
      }
    },
  };
  